import { RegistryTypeListProvider } from './../../../../../../../../../shared/cw-backend/providers/general/registry-type/registry-type-list.provider';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Firm, RegistryType } from '../../../../../../../../../shared/cw-backend/models/backend-definitions.module';
import { FirmEditProvider } from '../../../../../../../../../shared/cw-backend/providers/general/firm/firm-edit.provider';

@Component({
    selector: 'app-quick-registration-firm',
    templateUrl: './quick-registration-firm.component.html',
    styleUrls: ['./quick-registration-firm.component.scss']
})
export class QuickRegistrationFirmComponent implements OnInit {

    firmForm: FormGroup;
    firm = new Firm();
    registryTypeList: RegistryType[];
    loading: boolean = false;

    constructor(
        public _matDialogRef: MatDialogRef<QuickRegistrationFirmComponent>,
        private _formBuilder: FormBuilder,
        private registryTypeListProvider: RegistryTypeListProvider,
        private firmEditProvider: FirmEditProvider,
    ) { }

    ngOnInit(): void {
        this.firmForm = this.createFirmForm();
        this.getregistryTypeList();
    }
    createFirmForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.firm.id],
            name: new FormControl(this.firm.name,
                [Validators.required, Validators.maxLength(255)]),
            fullName: new FormControl(this.firm.fullName,
                [Validators.required, Validators.maxLength(255)]),
            registryType: new FormControl(this.firm.registryType,
                [Validators.required]),
            registry: new FormControl(this.firm.registry,
                [Validators.required, Validators.maxLength(15)]),
            cnes: new FormControl(this.firm.cnes,
                [Validators.required, Validators.maxLength(7)]),
        });
    }

    // Get all registryTypes
    getregistryTypeList() {
        this.registryTypeListProvider.getAll().then(res => {
            this.registryTypeList = res.body
        });
    }

    async insert(action?): Promise<any> {
        this.loading = true;
        let data :Firm = this.firmForm.getRawValue();
        data.active = true;
        data.useOrder = true;
        
        await this.firmEditProvider.insert(data).then((res) => {
            this.firm = res.body.data;
            this.confirm();
            this.loading = false;
        }).catch(err => {
            this.loading = false;8
        });
    }

    confirm() {
        this._matDialogRef.close(this.firm);
    }

    dimiss() {
        this._matDialogRef.close();
    }

    displayFn(registryType?: any): string | undefined {
        if (!registryType) {
            return null;
        }
        return registryType.name;
    }

    // Compare object in select
    compareSelect(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return false;
        }
        return o1.id === o2.id;
    }
}
